import React from 'react';
import Head from 'next/head';

const description =
  "Need a customized website for your wedding? Choose from over 100 beautiful designs, personalize it, and share it instantly. It's completely free!";

type WebsiteDesignsPdpMetaProps = {
  themeName?: string;
  themeKey?: string;
};

const WebsiteDesignPdpMeta = (props: WebsiteDesignsPdpMetaProps): JSX.Element => {
  const { themeName, themeKey } = props;
  const title = `Free Wedding Website Templates ${themeName || ''}`;
  return (
    <Head>
      <title>{`${title} - Zola`}</title>
      <meta name="description" content={description} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta
        property="og:image"
        content="https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/favicon-rebrand/apple-touch-icon.png"
      />
      <meta name="twitter:site" content="@zola" />
      <meta name="twitter:card" content="summary" />
      <link
        rel="canonical"
        href={`https://www.zola.com/wedding-planning/website/design/${themeKey}`}
      />
    </Head>
  );
};

export default WebsiteDesignPdpMeta;
